import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import CarrouselSponsoredPage from "./pages/carrouselSponsored";
import ListSponsoredPage from "./pages/listSponsored";
import TemplateTeamCard from "./pages/teamCard";
import LiveGamesPage from "./pages/liveGames";
import PositionTablePage from "./pages/positionTable";
import GameResultsPage from "./pages/gameResults";
import CarrouselCategoryPage from "./pages/carrouselCategory";
import CarrouselTeamPage from "./pages/carrouselTeam";
import CarrouselSponsoredUnoPage from "./pages/carrouselSponsoredUno";
import HomeResultsPage from "./pages/homeResults";
import SimulatorPage from "./pages/simulator";
import SimulatorSuperBowlPage from "./pages/simulatorSuperBowl";
import SimulatorWorldCupPage from "./pages/simulatorWorldCup";
import SimulatorSelectionMX from "./components/simulatorSelectionMX/simulatorSelectionMX";
import SimulatorSelectionCOLPage from "./pages/simulatorSelectionCOL";
import SimulatorLineupCOLPage from "./pages/simulatorLineupCOL";
import SimulatorLineupMXPage from "./pages/simulatorLineupMX";
import SimulatorLineupARGPage from "./pages/simulatorLineupARG";
import TickerClarosportsPage from "./pages/tickerClarosports";
import LeagueCheckPage from "./pages/leagueCheck";
import LigaTVPage from "./pages/ligaTV";
import PartidoTVPage from "./pages/partidoTV";
import MinuteByMinutePage from "./pages/minuteByMinute";
import "../src/css/globalStyles.sass";


function App() {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/results/carrousel-sponsored" replace />} />
          <Route path="/results" element={<Navigate to="/results/carrousel-sponsored" replace />} />
          <Route path="/results/carrousel-sponsored" element={<CarrouselSponsoredPage />} />
          <Route path="/results/carrousel-sponsored-unotv" element={<CarrouselSponsoredUnoPage />} />
          <Route path="/results/carrousel-team" element={<CarrouselTeamPage />} />
          <Route path="/results/carrousel-teams" element={<CarrouselCategoryPage />} />

          <Route path="/results/list-sponsored" element={<ListSponsoredPage />} />
          <Route path="/results/game-results" element={<GameResultsPage />} />
          <Route path="/results/positions-table" element={<PositionTablePage />} />
          <Route path="/results/team-card" element={<TemplateTeamCard />} />

          <Route path="/results/live-games" element={<LiveGamesPage />} />

          <Route path="/results/hub" element={<HomeResultsPage />} />

          <Route path="/results/simulador" element={<SimulatorPage />} />

          <Route path="/results/simulador-playoff" element={<SimulatorSuperBowlPage />} />

          <Route path="/results/simulator-wc" element={<SimulatorWorldCupPage />} />
          <Route path="/results/simulator-selection-mx" element={<SimulatorSelectionMX />} />
          <Route path="/results/simulator-selection-col" element={<SimulatorSelectionCOLPage />} />
          <Route path="/results/simulator-lineup-col" element={<SimulatorLineupCOLPage />} />
          <Route path="/results/simulator-lineup-mx" element={<SimulatorLineupMXPage />} />
          <Route path="/results/simulator-lineup-arg" element={<SimulatorLineupARGPage />} />

          <Route path="/results/ticker-clarosports" element={<TickerClarosportsPage />} />
          <Route path="/results/league-check" element={<LeagueCheckPage />} />
          <Route path="/results/w-tv/liga/:idligas" element={<LigaTVPage />} />
          <Route path="/results/w-tv/partido/:match" element={<PartidoTVPage />} />

          <Route path="/results/minute-by-minute/:type/:match/score" element={<MinuteByMinutePage />} />
          <Route path="/results/minute-by-minute/:type/:match/preview" element={<MinuteByMinutePage />} />
          <Route path="/results/minute-by-minute/:type/:match/statistics" element={<MinuteByMinutePage />} />
          <Route path="/results/minute-by-minute/:type/:match/lineups" element={<MinuteByMinutePage />} />
          <Route path="/results/minute-by-minute/:type/:match/commentary" element={<MinuteByMinutePage />} />

        </Routes>
      </Router>
  );
}

export default App;


//abreviaciones de los deportes: motorsport, soccer, tenis, football, basketball, baseball
//estatus de los partidos -> finalizado: clarosports-finished-game ; error: clarosports-error-game ; proximo: clarosports-next-game ; envivo: clarosports-in-progress-game
//opciones para type: teams, league, sport

//urls ejemplos para llamar los componentes
// live-games?section=partidos-envivo&league=europe-league&filter=true
// list-sponsored?momios=true&url=nba&spon=caliente
// positions-table?sport=football&team=america&type=team
// team-card?ligue=ligamx&team=america
// carrousel-category?sport=football
// carrousel-sponsored?momios=true&spon=caliente&url=principales_manual
// carrousel-team?momios=true&spon=caliente&route=deportes&id=fut
// game-results
// section=partidos-envivo&league=champions-league&filter=true

// import { lazy, Suspense } from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import Loading from "./components/loading/loading";
// import "../src/css/globalStyles.sass";

// // Cada página se carga en su propio chunk, solo cuando se visita su ruta
// const CarrouselSponsoredPage = lazy(() => import("./pages/carrouselSponsored"));
// const CarrouselSponsoredUnoPage = lazy(() => import("./pages/carrouselSponsoredUno"));
// const CarrouselTeamPage = lazy(() => import("./pages/carrouselTeam"));
// const CarrouselCategoryPage = lazy(() => import("./pages/carrouselCategory"));
// const ListSponsoredPage = lazy(() => import("./pages/listSponsored"));
// const GameResultsPage = lazy(() => import("./pages/gameResults"));
// const PositionTablePage = lazy(() => import("./pages/positionTable"));
// const TemplateTeamCard = lazy(() => import("./pages/teamCard"));
// const LiveGamesPage = lazy(() => import("./pages/liveGames"));
// const HomeResultsPage = lazy(() => import("./pages/homeResults"));
// const SimulatorPage = lazy(() => import("./pages/simulator"));
// const SimulatorSuperBowlPage = lazy(() => import("./pages/simulatorSuperBowl"));
// const SimulatorWorldCupPage = lazy(() => import("./pages/simulatorWorldCup"));
// const SimulatorSelectionMX = lazy(() => import("./components/simulatorSelectionMX/simulatorSelectionMX"));
// const SimulatorSelectionCOLPage = lazy(() => import("./pages/simulatorSelectionCOL"));
// const SimulatorLineupCOLPage = lazy(() => import("./pages/simulatorLineupCOL"));
// const SimulatorLineupMXPage = lazy(() => import("./pages/simulatorLineupMX"));
// const SimulatorLineupARGPage = lazy(() => import("./pages/simulatorLineupARG"));
// const TickerClarosportsPage = lazy(() => import("./pages/tickerClarosports"));
// const LeagueCheckPage = lazy(() => import("./pages/leagueCheck"));

// function App() {
//   return (
//     <Router>
//       {/* Suspense envuelve las rutas: muestra <Loading /> mientras descarga el chunk de la página */}
//       <Suspense fallback={<Loading type="300px" />}>
//         <Routes>
//           <Route path="/" element={<Navigate to="/results/carrousel-sponsored" replace />} />
//           <Route path="/results" element={<Navigate to="/results/carrousel-sponsored" replace />} />
//           <Route path="/results/carrousel-sponsored" element={<CarrouselSponsoredPage />} />
//           <Route path="/results/carrousel-sponsored-unotv" element={<CarrouselSponsoredUnoPage />} />
//           <Route path="/results/carrousel-team" element={<CarrouselTeamPage />} />
//           <Route path="/results/carrousel-teams" element={<CarrouselCategoryPage />} />
//           <Route path="/results/list-sponsored" element={<ListSponsoredPage />} />
//           <Route path="/results/game-results" element={<GameResultsPage />} />
//           <Route path="/results/positions-table" element={<PositionTablePage />} />
//           <Route path="/results/team-card" element={<TemplateTeamCard />} />
//           <Route path="/results/live-games" element={<LiveGamesPage />} />
//           <Route path="/results/hub" element={<HomeResultsPage />} />
//           <Route path="/results/simulador" element={<SimulatorPage />} />
//           <Route path="/results/simulador-playoff" element={<SimulatorSuperBowlPage />} />
//           <Route path="/results/simulator-wc" element={<SimulatorWorldCupPage />} />
//           <Route path="/results/simulator-selection-mx" element={<SimulatorSelectionMX />} />
//           <Route path="/results/simulator-selection-col" element={<SimulatorSelectionCOLPage />} />
//           <Route path="/results/simulator-lineup-col" element={<SimulatorLineupCOLPage />} />
//           <Route path="/results/simulator-lineup-mx" element={<SimulatorLineupMXPage />} />
//           <Route path="/results/simulator-lineup-arg" element={<SimulatorLineupARGPage />} />
//           <Route path="/results/ticker-clarosports" element={<TickerClarosportsPage />} />
//           <Route path="/results/league-check" element={<LeagueCheckPage />} />
//         </Routes>
//       </Suspense>
//     </Router>
//   );
// }

// export default App;